import { useGetMyAdminPermissionsQuery } from '@store/api/adminApi'
import { hasAdminPermission } from '@utils/adminPermissions'

export function useAdminPermissions() {
  const { data, isLoading, isError } = useGetMyAdminPermissionsQuery()

  const permissions = data?.data?.permissions ?? []
  const role = data?.data?.role ?? ''

  const can = (permission: string) => hasAdminPermission(permissions, permission)

  return {
    permissions,
    role,
    can,
    isLoading,
    isError,
    isReady: !isLoading && !isError,
  }
}

/** Gate admin pages by RBAC permission (aligned with ADMIN_NAV_PERMISSIONS). */
export function useAdminPageAccess(requiredPermission: string) {
  const { can, isLoading, isError, isReady } = useAdminPermissions()

  return {
    loading: isLoading,
    fetchError: isError,
    allowed: isReady && can(requiredPermission),
    denied: isReady && !can(requiredPermission),
  }
}
